var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m318.73 305.04c-3.8633 0.37891-7.4297 2.2227-9.9688 5.1602-2.5391 2.9336-3.8516 6.7305-3.6641 10.609 0.18359 3.875 1.8516 7.5312 4.6602 10.211l268.98 268.98-268.98 268.75c-2.9453 2.7969-4.6367 6.6602-4.6992 10.719-0.0625 4.0625 1.5117 7.9766 4.3672 10.863 2.8555 2.8867 6.75 4.5039 10.812 4.4844 4.0586-0.015624 7.9414-1.668 10.773-4.5781l268.98-268.98 268.99 268.98c2.832 2.9102 6.7148 4.5625 10.773 4.5781 4.0586 0.019532 7.957-1.5977 10.812-4.4844 2.8555-2.8867 4.4297-6.8008 4.3672-10.863-0.0625-4.0586-1.7578-7.9219-4.6992-10.719l-268.98-268.75 268.98-268.98c3.1484-2.957 4.8789-7.1133 4.7617-11.43-0.11719-4.3125-2.0703-8.3711-5.3711-11.152-3.3008-2.7812-7.6367-4.0156-11.906-3.3984-3.332 0.48438-6.4062 2.0625-8.7383 4.4883l-268.99 268.99-268.98-268.99c-3.2031-3.2812-7.7188-4.9297-12.281-4.4883z",
    fill: "#2c3960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1f14b765.svg";
export { ForwardRef as ReactComponent };